// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Minus: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 49"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M48.3 23.9c-.2-.6-.8-1-1.4-1H2c-.7 0-1.3.6-1.3 1.3v.7c0 .7.6 1.3 1.3 1.3l45-.1c.7 0 1.3-.6 1.3-1.3v-.9z"/></svg>;
};

export default React.memo(Minus);
